import React, { PureComponent } from 'react';

import Icon from '~/core/scripts/components/Icon';

class ClearIndicator extends PureComponent {
  render() {
    const { innerProps } = this.props;

    return (
      <button className="btn btn-clear" {...innerProps}>
        <Icon type="close" />
      </button>
    )
  }
}

export default ClearIndicator;
